/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2025 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2025 - Finnish Meteorological Institute (FMI)
 * Copyright 2025 - The Norwegian Meteorological Institute (MET Norway)
 * */

import { CustomToggleButton } from '@opengeoweb/shared';
import type { layerTypes } from '@opengeoweb/store';
import { useDataExplorerTranslation } from '../../utils/i18n';

interface DatasetAddRemoveButtonProps {
  layerName: string;
  foundLayer: layerTypes.Layer;
  disabled: boolean;
  addLayer: () => void;
  deleteLayer: () => void;
}

const DatasetAddRemoveButton: React.FC<DatasetAddRemoveButtonProps> = ({
  layerName,
  foundLayer,
  disabled,
  addLayer,
  deleteLayer,
}: DatasetAddRemoveButtonProps) => {
  const { t } = useDataExplorerTranslation();

  return (
    <CustomToggleButton
      data-testid={`datasetAddRemoveButton-${layerName}`}
      disabled={disabled}
      onClick={() => {
        !foundLayer ? addLayer() : deleteLayer();
      }}
      selected={!!foundLayer}
      sx={{
        fontSize: '12px',
        width: '64px',
        '@container (max-width:300px)': {
          height: '24px !important',
        },
      }}
      variant="tool"
    >
      {!foundLayer
        ? t('dataexplorer-add-dataset')
        : t('dataexplorer-remove-dataset')}
    </CustomToggleButton>
  );
};

export default DatasetAddRemoveButton;
